import Checkbox from "./Checkbox.js";
import { InputNumber, Space, Row } from "antd";
import StandardSubSettings from "./StandardSubSettings.js";

const TrafikverketSettings = ({ settings, saveSettings }) => {
  let localSettings = StandardSubSettings(settings, "Trafikverket");
  let useLocation = localSettings.useLocation;
  let maxDistance = localSettings.maxDistance;
  let notification = localSettings.notification;

  return (
    <div>
      <Checkbox
        name="Trafik-notification"
        text="Aktivera notiser vid Trafikverket"
        def={notification}
        onChange={() => {
          notification = !notification;
          localSettings.notification = notification;
          saveSettings(localSettings);
        }}
      />
      <Checkbox
        name="TrafikverketLocation"
        text="Använd din nuvarande plats"
        def={useLocation}
        onChange={() => {
          useLocation = !useLocation;
          localSettings.useLocation = useLocation;
          saveSettings(localSettings);
        }}
      />
      <Space>
        <p>Ange maximalt avstånd från din position (i km)</p>
        <InputNumber
          min={1}
          defaultValue={maxDistance}
          step={1}
          onChange={(value) => {
            if (value === null){value = 1;}
            localSettings.maxDistance = value;
            saveSettings(localSettings);
          }}
        />
      </Space>
      <Row style={{ padding: "10px" }}>
        <Space>
          <p style={{ margin: '10px 0px 0px 0px' }}> Avisera om ny data finns inom: </p>
          <InputNumber
            min={0}
            defaultValue={localSettings.newDataHour}
            onChange={(value) => {
              if (value === null){value = 0;}
              localSettings.newDataHour = value;
              saveSettings(localSettings);
            }}
            step={0.5}
          />
          <p style={{ margin: '10px 0px 0px 0px' }}>timmar</p>
        </Space>
      </Row>
    </div>
  );
};

export default TrafikverketSettings;
